import { Checkbox } from '@/global/components/Checkbox'
import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import {
    FormField,
    FormFieldCheckbox,
    FormFieldTime,
} from '@/global/components/Form'
import IconeAjuda from '@/global/components/IconeAjuda'
import Grid from '@/global/components/ui/Grid'
import { useFormContext } from 'react-hook-form'

export default function PausasForm() {
    const { watch, setValue } = useFormContext()

    const acumulaPausas = watch('pausasAcumulam')
    const tempoPausas = watch('tempoPausas')
    const maximoPausas = watch('maximoPausas')
    const incluirPausas = watch(
        'usarPausas',
        !!tempoPausas && tempoPausas !== '00:00',
    )

    const handleChangePausas = () => {
        setValue('usarPausas', !incluirPausas)

        if (incluirPausas) {
            setValue('tempoPausas', '00:00')
            setValue('maximoPausas', 1)
            setValue('pausasAcumulam', false)
            setValue('horasExtraPausas', false)
            setValue('faltaPausas', false)
        } else {
            setValue('tempoPausas', '00:10')
            setValue('maximoPausas', 2)
            setValue('pausasAcumulam', true)
            setValue('horasExtraPausas', false)
            setValue('faltaPausas', false)
        }
    }

    return (
        <Grid container>
            <Grid item xs={12} className="mb-4 mt-8">
                <HorizontalDivider>Pausas</HorizontalDivider>
            </Grid>
            <Grid item xs={3}>
                <Checkbox
                    checked={incluirPausas}
                    onCheckedChange={handleChangePausas}
                    containerClassName="select-none"
                    label="Incluir pausa"
                    endAdornment={
                        <IconeAjuda>
                            Este campo define se o sistema deve considerar
                            pausas ou não. Caso esteja marcado, o sistema vai
                            considerar pausas na jornada de trabalho do
                            funcionário.
                        </IconeAjuda>
                    }
                />
            </Grid>
            <Grid item xs={3}>
                <FormFieldTime
                    name="tempoPausas"
                    label="Tempo de pausa por turno"
                    placeholder="HH:mm"
                    disabled={!incluirPausas}
                    endAdornment={
                        <IconeAjuda className="mt-4">
                            Este campo define quanto tempo por turno será
                            considerado como pausa. O sistema não contabiliza
                            faltas para esse tempo.
                            <br />
                            <br />A carga horária de telemarketing, por exemplo,
                            prevê pausas de até 10 minutos.
                        </IconeAjuda>
                    }
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={3}>
                <FormField
                    name="maximoPausas"
                    label="Máximo de pausas por jornada"
                    min={1}
                    disabled={!incluirPausas}
                    onChange={e => {
                        if (Number(e.target.value) === 1) {
                            setValue('pausasAcumulam', false)
                        }
                    }}
                    type="number"
                    endAdornment={
                        <IconeAjuda className="mt-4 mr-1">
                            Este campo define quantas pausas serão consideradas
                            por jornada. O sistema não contabiliza faltas para
                            esse tempo.
                            <br />
                            <br />A carga horária de telemarketing, por exemplo,
                            prevê duas pausas por jornada.
                        </IconeAjuda>
                    }
                    autoComplete="off"
                    placeholder="0"
                />
            </Grid>
            <Grid item xs={3}>
                <FormFieldCheckbox
                    name="pausasAcumulam"
                    label="Acumular pausa"
                    onChange={checked => {
                        if (!checked) {
                            setValue('horasExtraPausas', false)
                            setValue('faltaPausas', false)
                        }
                    }}
                    disabled={!incluirPausas || Number(maximoPausas) < 2}
                    endAdornment={
                        <IconeAjuda>
                            Este campo define se as pausas acumulam ou não. Caso
                            esteja marcado, o sistema vai procurar quaisquer
                            faltas que com tempo menor que tempo de pausa
                            muiltiplicado pelo máximo de pausas por jornada.
                            <br />
                            <br />
                            Por exemplo, duas pausas de 10 minutos acumuladas
                            não consideram faltas mesmo se o funcionário faltar
                            15 minutos em um turno e 5 minutos em outro.
                        </IconeAjuda>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormFieldCheckbox
                    name="horasExtraPausas"
                    label="Incluir horas extras por pausas"
                    disabled={!incluirPausas || acumulaPausas}
                    endAdornment={
                        <IconeAjuda>
                            Este campo define se o sistema deve considerar horas
                            extras para pausas. Caso esteja marcado, o sistema
                            vai considerar horas extras para pausas.
                            <br />
                            <br />
                            Por exemplo, se um funcionário pausar 15 minutos em
                            uma pausa de 20 minutos, o sistema vai considerar 5
                            minutos como hora extra.
                        </IconeAjuda>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormFieldCheckbox
                    name="faltaPausas"
                    label="Incluir faltas por pausas"
                    disabled={!incluirPausas || acumulaPausas}
                    endAdornment={
                        <IconeAjuda>
                            Este campo define se o sistema deve considerar
                            faltas para pausas. Caso esteja marcado, o sistema
                            vai considerar faltas para pausas.
                            <br />
                            <br />
                            Por exemplo, se um funcionário pausar 25 minutos em
                            uma pausa de 20 minutos, o sistema vai considerar 5
                            minutos como falta.
                        </IconeAjuda>
                    }
                />
            </Grid>
        </Grid>
    )
}
